import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/InvOrders/ReportDelayLoad',
    method: 'post',
    data
  });
}

export function getloadfile(data) {
  return request({
    url: '/InvOrders/GetReportDelayLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
